import React from "react";
import IconButton from "@mui/material/IconButton";
import { Typography } from "@mui/material";

const CoreButtonIcon = ({
  icon,
  disabled,
  onClick,
  href,
  download,
  testo,
  className,
  p,
  color
}) => {
  return (
    <a href={href} download={download}>
      <IconButton
        disabled={disabled}
        disableRipple
        onClick={onClick}
        className={`p-${p}`}
      >
        {icon}
        <Typography style={{ color: color }} className={className}>{testo}</Typography>
      </IconButton>
    </a>
  );
};

export default CoreButtonIcon;